export default __webpack_public_path__ + "static/media/xyo-tokens-320x180.36db3c5d.jpg";